export function partition<T>(
  arr: T[],
  filter: (el: T, i: number, a: T[]) => boolean,
) {
  const fail: T[] = [];

  const pass = arr.filter((e, i, a) => {
    if (filter(e, i, a)) return true;
    fail.push(e);
  });

  return [pass, fail];
}
